import { CollapseAllButton, ExpandAllButton } from './ExpandCollapseButtons';

interface ITriggerExpandProps {
    setIsRowsExpanded: (isRowsExpanded: boolean) => void,
    isRowsExpanded: boolean,
    disabled?: boolean,
    className?: string,
}

export const TriggerExpand = ({ setIsRowsExpanded, isRowsExpanded, disabled, className }: ITriggerExpandProps) => {
    return isRowsExpanded ? (
      <CollapseAllButton
        onClick={ () => { setIsRowsExpanded(false); } }
        disabled={ disabled }
        className={ className }
      />
    ) : (
      <ExpandAllButton
        onClick={ () => { setIsRowsExpanded(true); } }
        disabled={ disabled }
        className={ className }
      />
    );
};
